import { Base, Component, Prop } from '@/vue-property-decorator'
import { useFooterStore } from '../../store'
import { windowOpen } from '@/utils/business-utils'
import AppTypes from '@/vue-types'
import style from './style.module.scss'

export interface Props {
  long?: number
  showTitle?: boolean
}

@Component<PhotographImgBox>({
  name: 'PhotographImgBox'
})
export default class PhotographImgBox extends Base {
  @Prop(AppTypes.number.def(50))
  private readonly long!: Props['long']
  store = useFooterStore()

  private get footerInfos() {
    return this.store.footerInfos
  }
  render() {
    const list =
      this.footerInfos?.qualificationProof?.filter?.(
        (i) => !!i.qualificationImage
      ) || []
    if (this.footerInfos?.partnerInfoStatus || list?.length === 0) {
      return <template></template>
    }
    return (
      <div class={[style.photographArea, 'photograp-area']}>
        {list.map((item, index) => (
          <my-img
            key={index}
            class={style.photoImg}
            src={item.qualificationImage}
            useSkeleton
            style={
              item.qualificationLink && {
                cursor: 'pointer'
              }
            }
            nativeOnClick={() => {
              if (item.qualificationLink) {
                windowOpen(item.qualificationLink)
              }
            }}
          />
        ))}
      </div>
    )
  }
}
